// extracted by mini-css-extract-plugin
export default {"mobileContainer":"styles_mobileContainer__Ic9f5","mobileContainerTitle":"styles_mobileContainerTitle__R5oWl","attach":"styles_attach__zazz0"};